/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkFlowImpacts {
    getFixupPrototypeFunction() { return WorkFlowImpacts.fixupPrototype; }

    static newInstance(model: Partial<WorkFlowImpacts>): WorkFlowImpacts {
        let obj = Object.assign(new WorkFlowImpacts(), model);
        WorkFlowImpacts.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkFlowImpacts>): WorkFlowImpacts {
        if (!model) return null;
        return WorkFlowImpacts.newInstance(<WorkFlowImpacts> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkFlowImpacts) {
        if (!obj) return;

        models.WorkFlowImpacts.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkFlowImpacts): boolean {
        Object.setPrototypeOf(obj, WorkFlowImpacts.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.rejection_duration_days === undefined) {
            this.rejection_duration_days = 0;
        }
        if (this.history_events) {
            for (let val of this.history_events) {
                models.WorkFlowEventHistory.fixupPrototype(val);
            }
        }
    }

    /**
     * Work Flow Id
     */
    workflow_id: string;

    /**
     * over all status of the workflow.
     */
    workflow_status: models.WorkFlowImpactStatus;

    /**
     * Reason for the rejection for the recommendation.
     */
    rejection_reason: string;

    /**
     * Number of days the customer rejects the recommendation
     */
    rejection_duration_days: number;

    history_events: Array<models.WorkFlowEventHistory>;

}
